export default "__VITE_ASSET__D9s3I_QS__"